import React from 'react'
import { t } from 'ttag'

import { CandidateManagementModal } from 'components/modals/CandidateManagementModal/CandidateManagementModal'
import { DeleteCandidateModal } from 'components/modals/DeleteCandidateModal/DeleteCandidateModal'
import { ImportCandidatesModal } from 'components/modals/ImportCandidatesModal/ImportCandidatesModal'
import { MoveCandidateModal } from 'components/modals/MoveCandidateModal/MoveCandidateModal'
import { DeleteCandidateGroupModal } from 'components/modals/DeleteCandidateGroupModal/DeleteCandidateGroupModal'
import { ExportCandidateGroupModal } from 'components/modals/ExportCandidateGroupModal/ExportCandidateGroupModal'
import { MoveCandidateGroupModal } from 'components/modals/MoveCandidateGroupModal/MoveCandidateGroupModal'
import { ActionsDropdown } from 'components/shared/ActionsDropdown/ActionsDropdown'
import { FilterDropdown } from 'components/shared/FilterDropdown/FilterDropdown'
import { Button } from 'components/shared/Button/Button'
import { Pane } from 'components/shared/Pane/Pane'
import { SearchWidget } from 'components/shared/SearchWidget/SearchWidget'
import { OverviewTable } from './common/OverviewTable/OverviewTable'
import { getFiltersConfigs } from '../model'
import { useJobOverviewTab } from './hooks'
import { PaneTitle } from '../PaneTitle/PaneTitle'
import { UploadCloudIcon, UserPlusIcon } from 'components/shared/Icon/model'

import styles from './Overview.module.scss'

export const Overview = ({ activeTab, project, hasInterviewModule }) => {
  const { id, name, active } = project ?? {}

  const { state, handlers } = useJobOverviewTab({ projectId: id })

  const {
    actions,
    candidate,
    count,
    search,
    filter,
    hasMoveCandidatesFeature,
    isAtsLocked,
    isCandidateManagementModalOpen,
    isDeleteCandidateModalOpen,
    isMoveCandidateModalOpen,
    isImportCandidatesModalOpen,
    isDeleteCandidateGroupModalOpen,
    isExportCandidateGroupModalOpen,
    isMoveCandidateGroupModalOpen,
  } = state
  const {
    getActions,
    handleFavorite,
    handleCandidateManagementModalClose,
    handleCandidateManagementModalConfirm,
    handleCandidateManagementModalOpen,
    handleDeleteCandidateModalConfirm,
    handleDeleteCandidateModalClose,
    handleMoveCandidateModalClose,
    handleMoveCandidateModalConfirm,
    handleImportCandidatesModalClose,
    handleImportCandidatesModalConfirm,
    handleImportCandidatesModalOpen,
    handleDeleteCandidateGroupModalClose,
    handleDeleteCandidateGroupModalConfirm,
    handleExportCandidateGroupModalClose,
    handleMoveCandidateGroupModalClose,
    handleMoveCandidateGroupModalConfirm,
    setSearch,
    setFilter,
  } = handlers

  return (
    <>
      <Pane.Header
        direction="column"
        subtitle={`${count} ${t`candidates`}`}
        title={<PaneTitle label={name} active={active} />}
      >
        <SearchWidget query={search} onChange={setSearch} />
        <FilterDropdown
          size="small"
          filter={filter}
          setFilter={setFilter}
          filtersConfig={getFiltersConfigs()}
        />
        <Button
          className={styles.button}
          color="primary"
          icon={UserPlusIcon}
          label={t`Add candidate`}
          size="small"
          variant="filled"
          onClick={handleCandidateManagementModalOpen}
          isLocked={isAtsLocked}
          isDisabled={!active}
        />
        <Button
          className={styles.button}
          icon={UploadCloudIcon}
          label={t`Import`}
          size="small"
          variant="outlined"
          onClick={handleImportCandidatesModalOpen}
          isLocked={isAtsLocked}
          isDisabled={!active}
        />
        <ActionsDropdown
          anchorClassName={styles.button}
          size="small"
          isDisabled={!active}
          {...{ actions }}
        />
      </Pane.Header>
      <OverviewTable
        projectId={id}
        tab={activeTab}
        {...{
          search,
          filter,
          setFilter,
          getActions,
          hasInterviewModule,
          handleFavorite,
          active,
        }}
      />
      <CandidateManagementModal
        onCancel={handleCandidateManagementModalClose}
        onClose={handleCandidateManagementModalClose}
        onConfirm={handleCandidateManagementModalConfirm}
        isOpen={isCandidateManagementModalOpen}
        {...{ candidate }}
      />
      <ImportCandidatesModal
        onCancel={handleImportCandidatesModalClose}
        onClose={handleImportCandidatesModalClose}
        onConfirm={handleImportCandidatesModalConfirm}
        isOpen={isImportCandidatesModalOpen}
      />
      {hasMoveCandidatesFeature ? (
        <MoveCandidateGroupModal
          onCancel={handleMoveCandidateGroupModalClose}
          onClose={handleMoveCandidateGroupModalClose}
          onConfirm={handleMoveCandidateGroupModalConfirm}
          isOpen={isMoveCandidateGroupModalOpen}
        />
      ) : null}
      <ExportCandidateGroupModal
        onCancel={handleExportCandidateGroupModalClose}
        onClose={handleExportCandidateGroupModalClose}
        isOpen={isExportCandidateGroupModalOpen}
      />
      <DeleteCandidateGroupModal
        onCancel={handleDeleteCandidateGroupModalClose}
        onClose={handleDeleteCandidateGroupModalClose}
        onConfirm={handleDeleteCandidateGroupModalConfirm}
        isOpen={isDeleteCandidateGroupModalOpen}
      />
      {hasMoveCandidatesFeature ? (
        <MoveCandidateModal
          name={candidate?.name}
          onCancel={handleMoveCandidateModalClose}
          onClose={handleMoveCandidateModalClose}
          onConfirm={handleMoveCandidateModalConfirm}
          isOpen={isMoveCandidateModalOpen}
        />
      ) : null}
      <DeleteCandidateModal
        name={candidate?.name}
        onCancel={handleDeleteCandidateModalClose}
        onClose={handleDeleteCandidateModalClose}
        onConfirm={handleDeleteCandidateModalConfirm}
        isOpen={isDeleteCandidateModalOpen}
      />
    </>
  )
}
